module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-edit"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera"
  }), _vm._v("\n          " + _vm._s(_vm.isEdit ? '编辑课程' : '新增课程') + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "page-subtitle"
  }, [_vm._v(_vm._s(_vm.isEdit ? '修改课程信息' : '创建新的课程内容'))])]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saving ? '保存中...' : '保存') + "\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "course-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    staticClass: "form-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-edit-outline"
  }), _vm._v(" "), _c('span', [_vm._v("基础信息")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入课程名称，最大30个字符",
      "maxlength": 30,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }, [_c('i', {
    staticClass: "el-icon-edit",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程分类",
      "prop": "typeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择课程分类",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.form.typeId),
      callback: function($$v) {
        _vm.$set(_vm.form, "typeId", $$v)
      },
      expression: "form.typeId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": String(category.id)
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程类型",
      "prop": "courseType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择课程类型",
      "clearable": ""
    },
    model: {
      value: (_vm.form.courseType),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseType", $$v)
      },
      expression: "form.courseType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "免费",
      "value": "1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#67C23A"
    }
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v(" 免费\n                  ")])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "VIP",
      "value": "2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _vm._v(" VIP\n                  ")])])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运动时长（秒）",
      "prop": "exerciseDurationSec"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 86400,
      "placeholder": "请输入运动时长（秒）"
    },
    model: {
      value: (_vm.form.exerciseDurationSec),
      callback: function($$v) {
        _vm.$set(_vm.form, "exerciseDurationSec", $$v)
      },
      expression: "form.exerciseDurationSec"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适合人群",
      "prop": "targetPeople"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择适合人群",
      "clearable": ""
    },
    model: {
      value: (_vm.form.targetPeople),
      callback: function($$v) {
        _vm.$set(_vm.form, "targetPeople", $$v)
      },
      expression: "form.targetPeople"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "零基础",
      "value": "1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#909399"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 零基础\n                  ")])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动小白",
      "value": "2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#67C23A"
    }
  }, [_c('i', {
    staticClass: "el-icon-user-solid"
  }), _vm._v(" 运动小白\n                  ")])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "初级运动者",
      "value": "3"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#409EFF"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-off"
  }), _vm._v(" 初级运动者\n                  ")])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "中级运动者",
      "value": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#E6A23C"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _vm._v(" 中级运动者\n                  ")])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "高级运动者",
      "value": "5"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_c('i', {
    staticClass: "el-icon-trophy"
  }), _vm._v(" 高级运动者\n                  ")])])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动部位",
      "prop": "targetBodyParts"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动部位，如：手臂、腿部、腹部",
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.targetBodyParts),
      callback: function($$v) {
        _vm.$set(_vm.form, "targetBodyParts", $$v)
      },
      expression: "form.targetBodyParts"
    }
  }, [_c('i', {
    staticClass: "el-icon-location-outline",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否推荐"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "推荐",
      "inactive-text": "不推荐",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.recommend),
      callback: function($$v) {
        _vm.$set(_vm.form, "recommend", $$v)
      },
      expression: "form.recommend"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否上架"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "上架",
      "inactive-text": "下架",
      "active-color": "#409EFF"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "form-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  }), _vm._v(" "), _c('span', [_vm._v("媒体资源")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程图片"
    }
  }, [_c('div', {
    staticClass: "media-upload-container"
  }, [_c('el-upload', {
    staticClass: "image-uploader",
    attrs: {
      "action": "#",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.handleImageChange,
      "before-upload": _vm.beforeImageUpload,
      "accept": "image/jpeg,image/png"
    }
  }, [((_vm.form.pictureUrl || _vm.previewImageUrl) && !_vm.imageUploading) ? _c('div', {
    staticClass: "uploaded-content"
  }, [_c('img', {
    staticClass: "uploaded-image",
    attrs: {
      "src": _vm.form.pictureUrl || _vm.previewImageUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "upload-actions"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.previewImage.apply(null, arguments)
      }
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-delete"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeImage.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])], 1)])]) : (_vm.imageUploading) ? _c('div', {
    staticClass: "upload-progress-container"
  }, [_c('div', {
    staticClass: "progress-content"
  }, [_c('i', {
    staticClass: "el-icon-loading upload-loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v("上传中...")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.imageUploadProgress,
      "show-text": false,
      "stroke-width": 4,
      "color": "#409eff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.imageUploadProgress) + "%")])], 1)]) : _c('div', {
    staticClass: "upload-placeholder"
  }, [_c('div', {
    staticClass: "upload-icon-container"
  }, [_c('i', {
    staticClass: "el-icon-plus upload-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("点击上传图片")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("支持 JPG、PNG 格式，大小不超过 2MB")])])])], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程视频"
    }
  }, [_c('div', {
    staticClass: "media-upload-container"
  }, [_c('el-upload', {
    staticClass: "video-uploader",
    attrs: {
      "action": "#",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.handleVideoChange,
      "before-upload": _vm.beforeVideoUpload,
      "accept": "video/mp4,video/avi,video/mov"
    }
  }, [((_vm.form.videoUrl || _vm.previewVideoUrl) && !_vm.videoUploading) ? _c('div', {
    staticClass: "uploaded-content"
  }, [_c('div', {
    staticClass: "video-preview"
  }, [_c('video', {
    staticClass: "preview-video",
    attrs: {
      "src": _vm.form.videoUrl || _vm.previewVideoUrl,
      "controls": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-name"
  }, [_vm._v(_vm._s(_vm.videoFileName))])]), _vm._v(" "), _c('div', {
    staticClass: "upload-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "upload-actions"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.previewVideo.apply(null, arguments)
      }
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-delete"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeVideo.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])], 1)])]) : (_vm.videoUploading) ? _c('div', {
    staticClass: "upload-progress-container"
  }, [_c('div', {
    staticClass: "progress-content"
  }, [_c('i', {
    staticClass: "el-icon-loading upload-loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v("上传中...")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.videoUploadProgress,
      "show-text": false,
      "stroke-width": 4,
      "color": "#409eff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.videoUploadProgress) + "%")])], 1)]) : _c('div', {
    staticClass: "upload-placeholder"
  }, [_c('div', {
    staticClass: "upload-icon-container"
  }, [_c('i', {
    staticClass: "el-icon-video-camera upload-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("点击上传视频")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("支持 MP4 格式，大小不超过 100MB")])])])], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程封面"
    }
  }, [_c('div', {
    staticClass: "media-upload-container"
  }, [_c('el-upload', {
    staticClass: "image-uploader",
    attrs: {
      "action": "#",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.handleCoverChange,
      "before-upload": _vm.beforeImageUpload,
      "accept": "image/jpeg,image/png"
    }
  }, [((_vm.form.coverUrl || _vm.previewCoverUrl) && !_vm.coverUploading) ? _c('div', {
    staticClass: "uploaded-content"
  }, [_c('img', {
    staticClass: "uploaded-image",
    attrs: {
      "src": _vm.form.coverUrl || _vm.previewCoverUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "upload-actions"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.previewCover.apply(null, arguments)
      }
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-delete"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeCover.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])], 1)])]) : (_vm.coverUploading) ? _c('div', {
    staticClass: "upload-progress-container"
  }, [_c('div', {
    staticClass: "progress-content"
  }, [_c('i', {
    staticClass: "el-icon-loading upload-loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v("上传中...")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "percentage": _vm.coverUploadProgress,
      "show-text": false,
      "stroke-width": 4,
      "color": "#409eff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.coverUploadProgress) + "%")])], 1)]) : _c('div', {
    staticClass: "upload-placeholder"
  }, [_c('div', {
    staticClass: "upload-icon-container"
  }, [_c('i', {
    staticClass: "el-icon-plus upload-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-text"
  }, [_vm._v("点击上传封面")]), _vm._v(" "), _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("支持 JPG、PNG 格式，大小不超过 2MB")])])])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "form-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c('span', [_vm._v("详细描述")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程介绍",
      "prop": "introduce"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入课程介绍，详细描述课程内容、特色和适用人群等信息",
      "maxlength": 200,
      "rows": 6,
      "show-word-limit": "",
      "resize": "none"
    },
    model: {
      value: (_vm.form.introduce),
      callback: function($$v) {
        _vm.$set(_vm.form, "introduce", $$v)
      },
      expression: "form.introduce"
    }
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-252c555e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/course/courseEdit.vue
// module id = 972
// module chunks = 0